<div id="partner-details">
    <ng-container *ngIf="isLoggedInTokenValid">
        <app-promotion-hero [isWebView]="isWebView" [partnerDetails]="partnerDetails"></app-promotion-hero>
    </ng-container>
    <ng-container *ngIf="!isLoggedInTokenValid">

    </ng-container>
</div>
